import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],

});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllRapportStagiaire({ commit }, params = {}) {
        const { page = 0, size = 10, sort = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let data = await client.get('rapports/stagiaire');
        return data;
    },
    async getAllRapportMaitre({ commit }, params = {}) {
        const { page = 0, size = 10, sort = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let data = await client.get('rapports/maitre');
        return data;
    },
    async getAllP(cxt, params) {
        const { page = 0, size = 10, sort = ''} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let data = await client.get('rapports?' + queryParams);
        cxt.commit("SET_ALL", data.data);
        return data.data;
    },
    async getOne(cxt, id) {
        let data = await client.get('rapports/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('rapports/edit/' + payload.id, payload) : await client.post('rapports/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('rapports/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    
   
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
